export const takeObjects = (array) => {
    const finalArray = [];
    for (const el of array) {
        for (const _el of el) {
            finalArray.push(_el);
        }
    }
    return finalArray;
}